import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as loaderActions from '../../actions/loader';
import styles from './image.module.scss';

class ImageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
    this.onLoadHandler = this.onLoadHandler.bind(this);
  }

  onLoadHandler() {
    this.setState({ loaded: true, });
  }

  render() {
    const { url } = this.props.img;
    const { alt } = this.props;
    const cssClass = [styles.bgimage, ...this.props.className];
    if (this.state.loaded) {
      cssClass.push(styles.in);
    }
    return (
      <img
        className={cssClass.join(' ')}
        src={`${url}`}
        onLoad={this.onLoadHandler}
        alt={alt}
      />
    );
  }
}

ImageContainer.defaultProps = { };

ImageContainer.propTypes = { };

const mapStateToProps = (state) => {
  return { }
}

const mapDispatchToProps = (dispatch) => {
  return { }
}

const Image = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImageContainer);

export default Image;

export const imageFragment = graphql`
fragment Image on ArticleJson {
  data {
    image {
      url
      dimensions {
        width
        height
      }
    }
  }
}`;



// WEBPACK FOOTER //
// ./src/components/Image/index.jsx